// Копирайт главного экрана — spec/08_copy.md, раздел «Главный экран» (без ротационного
// «Ответа Луни на отметку» — он в copy/pools.ts).
//
// Голос — вариант A «своя в чате» (docs/copy-variants.md, выбор основателя): рубленые фразы,
// мем впереди нежности. Тревожные места (вечерний нудж) остаются мягкими: там ирония выключена.
//
// Фразы о самой пользовательнице склоняются по её полу из профиля (`user.gender`): раньше они
// были в женском роде для всех. Пол не указан — берётся нейтральная формулировка.
import { textByGender } from '@lunya/contracts'

import type { MainCopy } from './types'

export const main: MainCopy = {
  share_message: 'Луня сказала, что у меня за день 🐾',
  greeting: ({ name }) => `${name}, привет 🐾`,
  forecast_overline: 'ПРЕДСКАЗАНИЕ ДНЯ',
  // В `what` приезжает текст вчерашнего предсказания целиком — законченное предложение, а не
  // обрывок вроде «день сюрпризов». Поэтому оно идёт цитатой, а точка в конце снимается:
  // «Вчера я предсказала: „Кто-то опоздает. Не ты“. Ну как, сбылось?».
  yesterday_q: ({ what }) =>
    `Вчера я предсказала: «${what.trim().replace(/[.!?…]+$/, '')}». Ну как, сбылось?`,
  // Кнопки ответа на вчерашнее предсказание. Были «Ага» / «Мимо»: разговорно, но на кнопке
  // читается как реплика, а не как ответ на вопрос «сбылось?» (правка редактора).
  yes: 'Да',
  no: 'Нет',
  hit: ({ n }) => `Я же говорила 💅 ${n}-е подряд`,
  miss: 'Пф. Звёзды моргнули. Завтра отыграюсь.',
  mood_q: 'Как ты сейчас?',
  mood_1: 'Тяжко',
  mood_2: 'Так себе',
  mood_3: 'Норм',
  mood_4: 'Сияю',
  mood_done: ({ mood }) => `Записала: сегодня ты ${mood} · изменить`,
  links_title: 'Твои узы ›',
  links_counter: ({ n, limit }) => `${n} из ${limit}`,
  natal_cta: 'Построить натальную карту',
  natal_sub: ({ gender }) =>
    textByGender(gender, 'небо в минуту, когда ты появил{ся|ась}', 'небо в минуту твоего рождения'),
  forecast_error: 'Звёзды тупят. Минуту.',
  evening_badge: 'твои ждут',
  evening_body: ({ gender }) =>
    textByGender(
      gender,
      'Ты сегодня не показывал{ся|ась}. Твои волнуются.',
      'Тебя сегодня не видно. Твои волнуются.',
    ),
  empty_links: 'Пусто. Показывай своих, буду приглядывать.',
  empty_cta: 'Позвать подругу 💫',
  lunya_node: 'Луня · всегда тут',
}
